import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import LocalAuthProvider from './LocalAuthProvider';

// Check if we're in test/local auth mode
const isTestEnvironment = process.env.REACT_APP_AUTH_MODE === 'local' ||
                          process.env.REACT_APP_ENVIRONMENT === 'test';

const Auth0ProviderWithNavigate = ({ children }) => {
    const navigate = useNavigate();

    // If in test environment, use local authentication
    if (isTestEnvironment) {
        return (
            <LocalAuthProvider>
                {children}
            </LocalAuthProvider>
        );
    }

    // Production: use Auth0
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL || `${window.location.origin}/admin/callback`;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || '/admin/dashboard');
    };

    if (!domain || !clientId) {
        console.error('Auth0 domain and clientId are required');
        return <div>Auth0 configuration error. Please check environment variables.</div>;
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: redirectUri,
                audience: audience,
                scope: 'openid profile email'
            }}
            onRedirectCallback={onRedirectCallback}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithNavigate;
